const GenerateSearchListParams = (url, query, coords = null, overideUrl = null) => {
    const requestObj = {
        'url': url,
        'amenities': query.getAll('amenity').length ? query.getAll('amenity') : [],
        'activityGroupIds': query.getAll('activityGroup').length ? query.getAll('activityGroup') : [],
        'discountCategoryIds': query.getAll('discountCategory').length ? query.getAll('discountCategory') : [],
        'cards': query.getAll('cards').length ? query.getAll('cards') : [],
        'sort': query.get('sort') ? query.get('sort') : 'AZ',
        'lat': coords ? coords.lat : 0,
        'lng': coords ? coords.lng : 0,
        'city': query.get('city') ? query.get('city') : '',
        'activityFacility': query.get('activityFacility') ? query.get('activityFacility') : ''
    }
    const overideUrlParams = () => {
        Object.keys(overideUrl).forEach(key=>{
            requestObj[key]= overideUrl[key];
        })
    }
    if(overideUrl !== null){
        overideUrlParams();
    }
    return requestObj;
}
export default GenerateSearchListParams;